var $ = require('jquery')
var ScrollTopComponent = require('../scrollTop/index')

module.exports = ScrollTopComponent.extend({
  initialize: function () {
    var scrollButton = $('.scroll-to-top-sticky-button')
    var rightEdge = (($(document).width() - this.$el.width()) / 2) * -1 + 20
    var $win = $(window)
    var footerHeight = $('.footer-area').height()

    $win.on('scroll', function () {
      var scrollTop = $win.scrollTop()
      var windowHeight = $win.height()
      var documentHeight = $(document).height()
      if (scrollTop) {
        scrollButton.fadeIn()
      } else {
        scrollButton.fadeOut()
      }
      if (scrollTop + windowHeight < documentHeight - footerHeight) {
        scrollButton.css({
          'position': 'fixed',
          'right': '20px'
        })
      } else {
        scrollButton.css({
          'position': 'absolute',
          'right': rightEdge
        })
      }
    })
  }
})
